import { Pipe, PipeTransform } from "@angular/core";
import { Dayjs } from "dayjs";
import { LOREN_DATE } from "../../../constants/loren-date.constants";
import { LorenDateUtilsService } from "../../../services/loren-date-utils-service/loren-date-utils.service";

@Pipe({
    name: "lorenDate",
    standalone: false
})
export class LorenDatePipe implements PipeTransform {
  transform(
    value: Dayjs | string | Date,
    format: string = LOREN_DATE.globalDateFormat
  ): string {
    if (!value) {
      return null;
    }

    return LorenDateUtilsService.getMomentFromDate(value).format(format);
  }
}
